import { render, staticRenderFns } from "./SelectAvatar.vue?vue&type=template&id=57be6aa3&scoped=true&"
import script from "./SelectAvatar.vue?vue&type=script&lang=js&"
export * from "./SelectAvatar.vue?vue&type=script&lang=js&"
import style0 from "./SelectAvatar.vue?vue&type=style&index=0&id=57be6aa3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57be6aa3",
  null
  
)

export default component.exports